<meta-form
  [_meta]="_meta"
  [tiposMeta]="tiposMeta"
  [cursosOpt]="cursosOpt"
  [areas]="areas"
  [profesores]="profesores"
  [ambitos]="ambitos"
  [tags]="tags"
  [contexto]="contexto"
  [metaUnidadID]="metaUnidadID"
  [activeTab]="activeTab"
  [unidadId]="unidadId"
  (guardandoEvent)="guardandoActualizar($event)"
  (actualizar)="actualizar($event)"
></meta-form>
<div class="cm-botones" *ngIf="guardando">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>
<div class="cm-botones" *ngIf="!guardando">
  <button style="margin-right: 4px;" mat-button (click)="cancelar()" [disabled]="guardando"
    i18n="@@cancelar">Cancelar</button>
  <button mat-raised-button color="primary" (click)="guardar()" [disabled]="guardando" i18n="@@guardar">Guardar</button>
</div>